<template>
  <div class="ShopCategory overflow-auto">
      <div class="d-flex my-1 justify-content-around">
          <div class="category-item p-1" :key="category" v-for="category  in $categories">
            <router-link :to="'/category/' + category.slug">
              <img class="bg" v-lazy="$MEDIA + category.icon" :alt="category.name">
              <p class="text-center my-1">{{category.name}}</p>
            </router-link>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  name: 'ShopCategory'
}
</script>

<style scoped>
.bg{
  background-color: #e8acd4;
  box-shadow: #afafaf 0px 0px 6px 2px;
  border-radius: 50%;
}
img{
  width: 100px;
}
p{
  font-weight: bold;
}
.category-item:hover{
  text-shadow: 0px 9px 13px #9d9d9d;
  filter: drop-shadow(0px 6px 6px rgba(50, 50, 0, 0.2));
  position: relative;
  top: -5px;
}
.category-item{
  transition: .5s ease;
}
@media (min-width:768px)  {.d-flex{justify-content: space-evenly;}}
@media (min-width:1025px) {.d-flex{justify-content: space-evenly;}img{width: 150px;}}
@media (min-width:1281px) {.d-flex{justify-content: space-evenly;}img{width: 200px;}}
</style>
